var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bind-card-view"},[_c('div',{staticClass:"inpatient-card-bind"},[_c('EditPage',{attrs:{"ftype":_vm.ftype}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }